import { Card, CardContent } from "@/components/ui/card";

type EmptyStateProps = {
  title: string;
  description?: string;
};

export function EmptyState({ title, description }: EmptyStateProps) {
  return (
    <Card className="border-border/80 bg-card/95 shadow-none">
      <CardContent className="py-6 text-center">
        <p className="font-medium text-sm">{title}</p>
        {description ? <p className="mt-1 text-xs text-muted-foreground">{description}</p> : null}
      </CardContent>
    </Card>
  );
}

export function ErrorState({ title, description }: EmptyStateProps) {
  return (
    <Card className="border-destructive/45 bg-destructive/10 shadow-none">
      <CardContent className="py-6 text-center">
        <p className="font-medium text-sm text-destructive">{title}</p>
        {description ? <p className="mt-1 text-xs text-destructive/85">{description}</p> : null}
      </CardContent>
    </Card>
  );
}
